import { render, staticRenderFns } from "./FetchGroupDocs.vue?vue&type=template&id=d0ed2eaa&"
import script from "./FetchGroupDocs.vue?vue&type=script&lang=js&"
export * from "./FetchGroupDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports